import { Model } from "@vuex-orm/core";

export const QUESTION_TYPE = Object.freeze({
  singleChoice: "SINGLE_CHOICE",
  multiChoice: "MULTI_CHOICE",
  range: "RANGE",
  rating: "RATING",
  freeText: "FREE_TEXT",
});

export const FREQUENCIES = Object.freeze({
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
});

export const FREQUENCY_TRANSLATION_KEYS = Object.freeze({
  DAILY: "daily",
  WEEKLY: "weekly",
});

export const GRAPH_FILTER_ENUM = Object.freeze({
  sevenDays: "7D",
  oneMonth: "1M",
  oneYear: "1Y",
  all: "all",
});

export const MINIMUM_RATING = 1;

export default class EproQuestionnaire extends Model {
  static entity = "eproQuestionnaires";
  static primaryKey = "questionnaireId";

  static fields() {
    return {
      questionnaireId: this.attr(null),
      questionnaireCategory: this.attr(null),
      questionnaireDescription: this.attr(null),
      questionnaireTitle: this.attr(null),
      questionnaireItems: this.attr([]),
      questionnaireDuration: this.attr(null),
      questionnaireThemes: this.attr([]),
      numberOfQuestions: this.attr(0),
      scoreCalculation: this.attr(null),
      repeat: this.attr(null),
    };
  }

  static async getQuestionnaireById(questionnaireId) {
    return await this.api().get(`questionnaire/${questionnaireId}`, {
      dataTransformer: (response) => ({
        ...response.data.result,
        questionnaireId,
      }),
    });
  }
}
